import { Component } from '@angular/core';
import { environment } from 'environments/environment';
import { ReportsComponent } from '../../../shared/components/reports/reports.component';

@Component({
    templateUrl: './client-portal-client-consult-note-task-reports.component.html',
    imports: [ReportsComponent]
})
export class ClientPortalClientConsultNoteTaskReportsComponent {
  reportsUrl = `${environment.captureApi.url}/client_consult_note_task_reports`;

  constructor() {}
}
